<div class="card card-custom">
    <!-- Header -->
    <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
            <span class="text-muted">Nota: recomandarile sunt sortate dupa ordinea trimiterii</span>
        </h3>
    </div>
    <!--begin::Body-->
    <div class="card-body py-0">

        <!--begin::Table-->
        <div class="table-responsive">
            <table class="table table-head-custom table-vertical-center" id="kt_advance_table_widget_1">
                <thead>
                <tr class="text-left">
                    <th class="pr-0 pl-0" style="width: 150px">Nr</th>
                    <th>Nume</th>
                    <th>Recomandat de</th>
                    <th>Data trimiterii</th>
                    <th>Status</th>
                    <th>Tip</th>
                    <th>Email</th>
                    <th>Telefon</th>
                    <th class="pr-0 text-right">Actiuni</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let recommendation of paginateData; let i = index">
                    <td><p class="text-dark-75 font-weight-bolder font-size-lg">{{getIndex(recommendation.id)}}</p></td>
                    <td><p class="text-dark-75 font-weight-bolder font-size-lg">{{recommendation.name}}</p></td>
                    <td><p class="text-dark-75 font-weight-bolder font-size-lg">{{recommendation.recommendedBy}}</p></td>
                    <td><p class="text-dark-75 font-weight-bolder font-size-lg">{{recommendation.postingDate | date:'dd-MM-yyyy HH:mm:ss'}}</p></td>
                    <td><p class="text-dark-75 font-weight-bolder font-size-lg">{{recommendation.status | enumTransform}}</p></td>
                    <td><p class="text-dark-75 font-weight-bolder font-size-lg">{{recommendation.recommendationType === 'company' ? 'Companie' : 'Candidat'}}</p></td>
                    <td><p class="text-dark-75 font-weight-bolder font-size-lg"><a href="mailto:{{recommendation.email}}">{{recommendation.email}}</a></p></td>
                    <td><p class="text-dark-75 font-weight-bolder font-size-lg"><a href="tel:{{recommendation.telephone}}">{{recommendation.telephone}}</a></p></td>

                    <td class="pr-0 text-right">
                        <a class="btn btn-icon btn-success btn-hover-primary btn-sm"
                           (click)="viewMore(recommendation, i)"
                           ngbTooltip="Vezi" placement="bottom">
                            <i class="icofont-eye-alt"></i>
                        </a>
                        <a class="btn btn-icon btn-danger btn-hover-primary btn-sm"
                           (click)="deleteRecommendation(recommendation, i)"
                           ngbTooltip="Sterge" placement="bottom">
                            <i class="icofont-bin"></i>
                        </a>
                    </td>

                </tr>
                </tbody>
            </table>

        </div>
        <!--end::Table-->
    </div>
    <ngb-pagination class="d-flex justify-content-center" [collectionSize]="collectionSize" [maxSize]="5" [(page)]="page" [pageSize]="pageSize" (pageChange)="changePage();">
    </ngb-pagination>
    <!--end::Body-->
</div>
